import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// Redux context
import { Provider } from "react-redux";

// DnD context
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

// MUI theme
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "./theme";

// intl context
import ConnectedIntlProvider from "./components/connectedProviders/connectedIntlProvider";
import ConnectedLocalizationProvider from "./components/connectedProviders/connectedLocalizationProvider";

import NotFound from "./components/routes/notFound";
import AdminRoutes from "./components/routes/adminRoutes";
import LabourerRoutes from "./components/routes/labourerRoutes";

import Alert from "./components/alert/alert";
import Authenticate from "./Authenticate";
import store from "./redux/initializeRedux";

import "./App.css";
import "./global.css";

// addLocaleData([...locale_en, ...locale_fr]);

function App() {
    return (
        <div className="App">
            <ThemeProvider theme={theme}>
                <DndProvider backend={HTML5Backend}>
                    <Provider store={store}>
                        <ConnectedIntlProvider defaultLocale="en">
                            <ConnectedLocalizationProvider>
                                <Router>
                                    <Switch>
                                        <Authenticate adminRoutes={<AdminRoutes />} labourerRoutes={<LabourerRoutes />} />
                                        <Route component={NotFound} />
                                    </Switch>
                                </Router>
                                <Alert />
                            </ConnectedLocalizationProvider>
                        </ConnectedIntlProvider>
                    </Provider>
                </DndProvider>
            </ThemeProvider>
        </div>
    );
}

export default App;
